
// import React, { useState } from 'react';
// import { useDispatch } from 'react-redux';
// import { setUser } from '../Commonlibs/userSlice';
// import {
//   Box,
//   Button,
//   Checkbox,
//   FormControlLabel,
//   IconButton,
//   InputAdornment,
//   TextField,
//   Typography,
//   useMediaQuery,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogContentText,
//   DialogTitle
// } from '@mui/material';
// import { Visibility, VisibilityOff } from '@mui/icons-material';
// import { useTheme } from '@mui/material/styles';
// import { useNavigate } from 'react-router-dom';
// import Loader from '../Loader/Loader'; 
// import leftImage from '../assets/logip.png';
// import houseLogo from '../assets/lob.png';
// import emailIcon from '../assets/email.png';
// import lockIcon from '../assets/lock.png';
// import phoneIcon from '../assets/phone.png';

// const Register = () => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('md'));
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
  
//   const [showPassword, setShowPassword] = useState(false);
//   const [showConfirmPassword, setShowConfirmPassword] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [formData, setFormData] = useState({
//     fullName: '',
//     email: '',
//     password: '',
//     confirmPassword: '',
//     contactNumber: '',
//   });
//   const [errors, setErrors] = useState({});
//   const [agreed, setAgreed] = useState(false);
  
//   // Success dialog state
//   const [successDialogOpen, setSuccessDialogOpen] = useState(false);
  
//   const validateField = (name, value) => {
//     if (!value.trim()) return '';
//     switch (name) {
//       case 'fullName':
//         return /^[a-zA-Z ]+$/.test(value) ? '' : 'Name is invalid';
//       case 'email':
//         return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)
//           ? ''
//           : 'Email is invalid';
//       case 'password':
//   // Modified password validation to be simpler - just 6 characters minimum
//   return value.length >= 6
//     ? ''
//     : 'Password must be at least 6 characters';
//       case 'confirmPassword':
//         return value === formData.password ? '' : 'Passwords do not match';
//       case 'contactNumber':
//         return /^\d{10}$/.test(value) ? '' : 'Phone number must be 10 digits';
//       default:
//         return '';
//     }
//   };
  
//   const handleFieldChange = (fieldName, value) => {
//     setFormData({ ...formData, [fieldName]: value });
//     const error = validateField(fieldName, value);
//     setErrors((prev) => ({ ...prev, [fieldName]: error }));
    
//     // Special case for confirmPassword - validate when password changes
//     if (fieldName === 'password' && formData.confirmPassword) {
//       const confirmError = value === formData.confirmPassword ? '' : 'Passwords do not match';
//       setErrors((prev) => ({ ...prev, confirmPassword: confirmError }));
//     }
//   };
  
//   const validateOnSubmit = () => {
//     const newErrors = {};
//     let isValid = true;
//     Object.entries(formData).forEach(([key, value]) => {
//       if (!value.trim()) {
//         newErrors[key] =
//           key === 'contactNumber'
//             ? 'Phone number is required'
//             : `${key.charAt(0).toUpperCase() + key.slice(1)} is required`;
//         isValid = false;
//       } else {
//         const error = validateField(key, value);
//         newErrors[key] = error;
//         if (error) isValid = false;
//       }
//     });
//     setErrors(newErrors);
//     return isValid;
//   };
  
//   const handleNavigateToLogin = () => {
//     setSuccessDialogOpen(false);
//     navigate('/login');
//   };
  
//   const handleRegister = async () => {
//     if (!agreed) {
//       setErrors((prev) => ({ ...prev, agreed: 'Please agree to the Terms and Conditions.' }));
//       return;
//     }
    
//     if (!validateOnSubmit()) return;
    
//     setLoading(true);
    
//     const payload = {
//       full_name: formData.fullName,
//       email_id: formData.email,
//       password: formData.password,
//       contact_number: formData.contactNumber,
//       terms_conditions: agreed,
//     };
    
//     try {
//       const response = await fetch('http://localhost:3333/api/users/userRegistration', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(payload),
//       });
      
//       const data = await response.json();
      
//       if (response.ok && data.status === "SUCCESS") {
//         setSuccessDialogOpen(true);
//       } else {
//         setErrors((prev) => ({ ...prev, submit: data.message || 'Registration failed. Please try again.' }));
//       }
//     } catch (error) {
//       console.error('Error:', error);
//       setErrors((prev) => ({ ...prev, submit: 'Something went wrong. Please try again later.' }));
//     } finally {
//       setLoading(false);
//     }
//   };
  
//   return (
//     <Box
//       display="flex"
//       flexDirection={{ xs: 'column', md: 'row' }}
//       sx={{
//         width: '100%',
//         height: '100vh',
//         overflow: 'hidden'
//       }}
//     >
//       {/* Success Dialog */}
//       <Dialog
//         open={successDialogOpen}
//         onClose={() => setSuccessDialogOpen(false)}
//         aria-labelledby="success-dialog-title"
//         aria-describedby="success-dialog-description"
//         PaperProps={{
//           style: {
//             borderRadius: '8px',
//           }
//         }}
//       >
//         <DialogTitle id="success-dialog-title">
//           Registration Successful
//         </DialogTitle>
//         <DialogContent>
//           <DialogContentText id="success-dialog-description">
//             Your account has been created successfully!
//           </DialogContentText>
//         </DialogContent>
//         <DialogActions sx={{ justifyContent: 'center', pb: 2 }}>
//           <Button 
//             onClick={handleNavigateToLogin} 
//             color="primary" 
//             variant="contained"
//             autoFocus
//             sx={{
//               bgcolor: '#0052ff',
//               borderRadius: 2,
//               textTransform: 'none',
//             }}
//           >
//             CLICK TO LOGIN
//           </Button>
//         </DialogActions>
//       </Dialog>
      
//       {/* Custom Loader */}
//       {loading && <Loader />}
      
//       {/* Left Image */}
//       <Box
//         sx={{
//           display: { xs: 'flex', md: 'flex' },
//           width: { xs: '100%', md: '40%' },
//           height: { xs: '30vh', md: '100%' },
//           position: 'relative',
//           overflow: 'hidden',
//           boxShadow: { xs: 'none', md: '5px 0 15px rgba(0, 0, 0, 0.15)' },
//           backgroundColor: 'rgba(0,0,0,0.3)',
//           margin: 0,
//           padding: 0,
//         }}
//       >
//         <Box
//           sx={{
//             position: 'absolute',
//             width: '100%',
//             height: '100%',
//             top: 0,
//             left: 0,
//             backgroundColor: 'rgba(0, 0, 0, 0.3)',
//             zIndex: 1,
//           }}
//         />
//         <img
//           src={leftImage}
//           alt="Left"
//           style={{
//             width: '100%',
//             height: '100%',
//             objectFit: 'cover',
//             display: 'block',
//           }}
//         />
//       </Box>
      
//       {/* Right Section */}
//       <Box
//         sx={{
//           width: { xs: '100%', md: '60%' },
//           height: { xs: 'calc(100vh - 30vh)', md: '100%' },
//           overflowY: { xs: 'auto', md: 'hidden' },
//           display: 'flex',
//           flexDirection: 'column',
//           justifyContent: 'center',
//           alignItems: 'center',
//           backgroundColor: '#fff',
//           px: { xs: 2, sm: 3 },
//           py: { xs: 2, sm: 3 },
//           boxSizing: 'border-box',
//         }}
//       >
//         {/* Logo and Heading */}
//         <Box
//           display="flex"
//           justifyContent="center"
//           sx={{ mt: 4, mb: 0.5 }}
//         >
//           <img src={houseLogo} alt="logo" style={{ width: 45, height: 45 }} />
//         </Box>
        
//         <Typography
//           variant="h6"
//           textAlign="center"
//           mb={1}
//           fontWeight={500}
//           fontSize="17px"
//         >
//           Create your account
//         </Typography>
        
//         {/* Form Box */}
//         <Box
//           sx={{
//             width: '100%',
//             maxWidth: 320,
//             borderRadius: 3,
//             p: { xs: 1.5, sm: 2 },
//             boxShadow: '0 0 20px rgba(0,0,0,0.05)',
//             border: '1px solid #eee',
//             mb: 2,
//             mx: 'auto',
//           }}
//         >
//           <Typography fontWeight={500} fontSize={14} mb={0.5}>
//             Fill the required details
//           </Typography>
          
//           <TextField
//             fullWidth
//             placeholder="Enter your full name*"
//             margin="dense"
//             value={formData.fullName}
//             onChange={(e) => handleFieldChange('fullName', e.target.value)}
//             error={Boolean(errors.fullName)}
//             helperText={errors.fullName}
//             sx={{
//               mb: 0.5,
//               '& .MuiOutlinedInput-root': {
//                 borderRadius: '12px',
//               },
//               '& .MuiFormHelperText-root': {
//                 fontSize: '11px',
//                 marginTop: 0
//               }
//             }}
//             inputProps={{ style: { fontSize: 14 } }}
//           />
//           <TextField
//   fullWidth
//   placeholder="Phone Number*"
//   margin="dense"
//   value={formData.contactNumber}
//   onChange={(e) => {
//     // Only allow numeric input and limit to 10 digits
//     const newValue = e.target.value.replace(/\D/g, '').slice(0, 10);
//     handleFieldChange('contactNumber', newValue);
//   }}
//   error={Boolean(errors.contactNumber)}
//   helperText={errors.contactNumber}
//   sx={{
//     mb: 1,
//     '& .MuiOutlinedInput-root': {
//       borderRadius: '12px',
//     },
//     '& .MuiFormHelperText-root': {
//       fontSize: '11px',
//       marginTop: 0
//     }
//   }}
//   inputProps={{ 
//     style: { fontSize: 14 },
//     maxLength: 10 // Add maxLength attribute as an extra safeguard
//   }}
//   InputProps={{
//     startAdornment: (
//       <InputAdornment position="start">
//         <img src={phoneIcon} alt="phone" style={{ width: 18, marginRight: 10 }} />
//         <Typography variant="body2" sx={{ fontSize: 14, color: 'text.secondary' }}>
//           +91
//         </Typography>
//       </InputAdornment>
//     ),
//   }}
// />
          
          
//           {/* <TextField
//             fullWidth
//             type={showPassword ? 'text' : 'password'}
//             placeholder="Create your password*"
//             margin="dense"
//             value={formData.password}
//             onChange={(e) => handleFieldChange('password', e.target.value)}
//             error={Boolean(errors.password)}
//             helperText={errors.password}
//             sx={{
//               mb: 0.5,
//               '& .MuiOutlinedInput-root': {
//                 borderRadius: '12px',
//               },
//               '& .MuiFormHelperText-root': {
//                 fontSize: '11px',
//                 marginTop: 0
//               }
//             }}
//             inputProps={{ style: { fontSize: 14 } }}
//             InputProps={{
//               startAdornment: (
//                 <InputAdornment position="start">
//                   <img src={lockIcon} alt="lock" style={{ width: 18, marginRight: 10 }} />
//                 </InputAdornment>
//               ),
//               endAdornment: (
//                 <InputAdornment position="end">
//                   <IconButton onClick={() => setShowPassword(!showPassword)} size="small">
//                     {showPassword ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
//                   </IconButton>
//                 </InputAdornment>
//               ),
//             }}
//           /> */}
          
//           {/* <TextField
//             fullWidth
//             type={showConfirmPassword ? 'text' : 'password'}
//             placeholder="Confirm your password*"
//             margin="dense"
//             value={formData.confirmPassword}
//             onChange={(e) => handleFieldChange('confirmPassword', e.target.value)}
//             error={Boolean(errors.confirmPassword)}
//             helperText={errors.confirmPassword}
//             sx={{
//               mb: 0.5,
//               '& .MuiOutlinedInput-root': {
//                 borderRadius: '12px',
//               },
//               '& .MuiFormHelperText-root': {
//                 fontSize: '11px',
//                 marginTop: 0
//               }
//             }}
//             inputProps={{ style: { fontSize: 14 } }}
//             InputProps={{
//               startAdornment: (
//                 <InputAdornment position="start">
//                   <img src={lockIcon} alt="lock" style={{ width: 18, marginRight: 10 }} />
//                 </InputAdornment>
//               ),
//               endAdornment: (
//                 <InputAdornment position="end">
//                   <IconButton onClick={() => setShowConfirmPassword(!showConfirmPassword)} size="small">
//                     {showConfirmPassword ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
//                   </IconButton>
//                 </InputAdornment>
//               ),
//             }}
//           /> */}
          
//           <TextField
//             fullWidth
//             placeholder="Enter your email*"
//             margin="dense"
//             value={formData.email}
//             onChange={(e) => handleFieldChange('email', e.target.value)}
//             error={Boolean(errors.email)}
//             helperText={errors.email}
//             sx={{
//               mb: 0.5,
//               '& .MuiOutlinedInput-root': {
//                 borderRadius: '12px',
//               },
//               '& .MuiFormHelperText-root': {
//                 fontSize: '11px',
//                 marginTop: 0
//               }
//             }}
//             inputProps={{ style: { fontSize: 14 } }}
//             InputProps={{
//               startAdornment: (
//                 <InputAdornment position="start">
//                   <img src={emailIcon} alt="email" style={{ width: 18, marginRight: 10 }} />
//                 </InputAdornment>
//               ),
//             }}
//           />
          
//           {errors.submit && (
//             <Typography color="error" fontSize={12} mb={1}>
//               {errors.submit}
//             </Typography>
//           )}
          
//           <FormControlLabel
//             control={
//               <Checkbox
//                 size="small"
//                 checked={agreed}
//                 onChange={(e) => setAgreed(e.target.checked)}
//               />
//             }
//             sx={{ mt: 0.5, mb: 0.5 }}
//             label={
//               <Typography sx={{ fontSize: 12 }}>
//                 I agree to the{' '}
//                 <Typography component="span" sx={{ color: '#0052ff', fontWeight: 500, fontSize: 12 }}>
//                   Terms of Service
//                 </Typography>{' '}
//                 and{' '}
//                 <Typography component="span" sx={{ color: '#0052ff', fontWeight: 500, fontSize: 12 }}>
//                   Privacy Policy
//                 </Typography>
//               </Typography>
//             }
//           />
          
//           {errors.agreed && (
//             <Typography color="error" fontSize={12} mb={1}>
//               {errors.agreed}
//             </Typography>
//           )}
        
//           <Button
//             variant="contained"
//             fullWidth
//             disabled={loading}
//             onClick={handleRegister}
//             sx={{
//               bgcolor: '#0052ff',
//               color: '#fff',
//               py: 1.2,
//               fontWeight: 500,
//               borderRadius: 2,
//               mt: 1,
//               fontSize: 14,
//               textTransform: 'none',
//             }}
//           >
//             Create Account
//           </Button>
//         </Box>
//       </Box>
//     </Box>
//   );
// };

// export default Register;


import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { setUser } from '../Commonlibs/userSlice';
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
  useMediaQuery,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import Loader from '../Loader/Loader';
import leftImage from '../assets/logip.png';
import houseLogo from '../assets/lob.png';
import emailIcon from '../assets/email.png';
import lockIcon from '../assets/lock.png';
import phoneIcon from '../assets/phone.png';

const Register = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    contactNumber: '',
  });
  const [errors, setErrors] = useState({});
  const [agreed, setAgreed] = useState(false);
  
  // Success dialog state
  const [successDialogOpen, setSuccessDialogOpen] = useState(false);

  const validateField = (name, value) => {
    if (!value.trim()) return '';
    
    switch (name) {
      case 'fullName':
        return /^[a-zA-Z ]+$/.test(value) ? '' : 'Name is invalid';
      case 'email':
        return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)
          ? ''
          : 'Email is invalid';
      case 'contactNumber':
        return /^\d{10}$/.test(value) ? '' : 'Phone number must be 10 digits';
      default:
        return '';
    }
  };

  const handleFieldChange = (fieldName, value) => {
    setFormData({ ...formData, [fieldName]: value });
    const error = validateField(fieldName, value);
    setErrors((prev) => ({ ...prev, [fieldName]: error }));
  };

  const validateOnSubmit = () => {
    const newErrors = {};
    let isValid = true;

    Object.entries(formData).forEach(([key, value]) => {
      if (!value.trim()) {
        newErrors[key] =
          key === 'contactNumber'
            ? 'Phone number is required'
            : `${key.charAt(0).toUpperCase() + key.slice(1)} is required`;
        isValid = false;
      } else {
        const error = validateField(key, value);
        newErrors[key] = error;
        if (error) isValid = false;
      }
    });

    setErrors(newErrors);
    return isValid;
  };

  const handleNavigateToLogin = () => {
    setSuccessDialogOpen(false);
    navigate('/login');
  };

  const handleRegister = async () => {
    if (!agreed) {
      setErrors((prev) => ({ ...prev, agreed: 'Please agree to the Terms and Conditions.' }));
      return;
    }

    if (!validateOnSubmit()) return;

    setLoading(true);

    const payload = {
      full_name: formData.fullName,
      email_id: formData.email,
      contact_number: formData.contactNumber,
      terms_conditions: agreed,
    };

    try {
      const response = await fetch('https://propertydealstalk.com/api/users/userRegistration', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (response.ok && data.status === "SUCCESS") {
        setSuccessDialogOpen(true);
      } else {
        setErrors((prev) => ({ ...prev, submit: data.message || 'Registration failed. Please try again.' }));
      }
    } catch (error) {
      console.error('Error:', error);
      setErrors((prev) => ({ ...prev, submit: 'Something went wrong. Please try again later.' }));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      display="flex"
      flexDirection={{ xs: 'column', md: 'row' }}
      sx={{
        width: '100%',
        height: '100vh',
        overflow: 'hidden'
      }}
    >
      {/* Success Dialog */}
      <Dialog
        open={successDialogOpen}
        onClose={() => setSuccessDialogOpen(false)}
        aria-labelledby="success-dialog-title"
        aria-describedby="success-dialog-description"
        PaperProps={{
          style: {
            borderRadius: '8px',
          }
        }}
      >
        <DialogTitle id="success-dialog-title">
          Registration Successful
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="success-dialog-description">
            Your account has been created successfully!
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'center', pb: 2 }}>
          <Button
            onClick={handleNavigateToLogin}
            color="primary"
            variant="contained"
            autoFocus
            sx={{
              bgcolor: '#0052ff',
              borderRadius: 2,
              textTransform: 'none',
            }}
          >
            CLICK TO LOGIN
          </Button>
        </DialogActions>
      </Dialog>

      {/* Custom Loader */}
      {loading && <Loader />}

      {/* Left Image */}
      <Box
        sx={{
          display: { xs: 'flex', md: 'flex' },
          width: { xs: '100%', md: '40%' },
          height: { xs: '30vh', md: '100%' },
          position: 'relative',
          overflow: 'hidden',
          boxShadow: { xs: 'none', md: '5px 0 15px rgba(0, 0, 0, 0.15)' },
          backgroundColor: 'rgba(0,0,0,0.3)',
          margin: 0,
          padding: 0,
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            width: '100%',
            height: '100%',
            top: 0,
            left: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.3)',
            zIndex: 1,
          }}
        />
        <img
          src={leftImage}
          alt="Left"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            display: 'block',
          }}
        />
      </Box>

      {/* Right Section */}
      <Box
        sx={{
          width: { xs: '100%', md: '60%' },
          height: { xs: 'calc(100vh - 30vh)', md: '100%' },
          overflowY: { xs: 'auto', md: 'hidden' },
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: '#fff',
          px: { xs: 2, sm: 3 },
          py: { xs: 2, sm: 3 },
          boxSizing: 'border-box',
        }}
      >
        {/* Logo and Heading */}
        <Box
          display="flex"
          justifyContent="center"
          sx={{ mt: 4, mb: 0.5 }}
        >
          <img src={houseLogo} alt="logo" style={{ width: 45, height: 45 }} />
        </Box>
        <Typography
          variant="h6"
          textAlign="center"
          mb={1}
          fontWeight={500}
          fontSize="17px"
        >
          Create your account
        </Typography>

        {/* Form Box */}
        <Box
          sx={{
            width: '100%',
            maxWidth: 320,
            borderRadius: 3,
            p: { xs: 1.5, sm: 2 },
            boxShadow: '0 0 20px rgba(0,0,0,0.05)',
            border: '1px solid #eee',
            mb: 2,
            mx: 'auto',
          }}
        >
          <Typography fontWeight={500} fontSize={14} mb={0.5}>
            Fill the required details
          </Typography>

          <TextField
            fullWidth
            placeholder="Enter your full name*"
            margin="dense"
            value={formData.fullName}
            onChange={(e) => handleFieldChange('fullName', e.target.value)}
            error={Boolean(errors.fullName)}
            helperText={errors.fullName}
            sx={{
              mb: 0.5,
              '& .MuiOutlinedInput-root': {
                borderRadius: '12px',
              },
              '& .MuiFormHelperText-root': {
                fontSize: '11px',
                marginTop: 0
              }
            }}
            inputProps={{ style: { fontSize: 14 } }}
          />

          <TextField
            fullWidth
            placeholder="Phone Number*"
            margin="dense"
            value={formData.contactNumber}
            onChange={(e) => {
              // Only allow numeric input and limit to 10 digits
              const newValue = e.target.value.replace(/\D/g, '').slice(0, 10);
              handleFieldChange('contactNumber', newValue);
            }}
            error={Boolean(errors.contactNumber)}
            helperText={errors.contactNumber}
            sx={{
              mb: 1,
              '& .MuiOutlinedInput-root': {
                borderRadius: '12px',
              },
              '& .MuiFormHelperText-root': {
                fontSize: '11px',
                marginTop: 0
              }
            }}
            inputProps={{
              style: { fontSize: 14 },
              maxLength: 10
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <img src={phoneIcon} alt="phone" style={{ width: 18, marginRight: 10 }} />
                  <Typography variant="body2" sx={{ fontSize: 14, color: 'text.secondary' }}>
                    +91
                  </Typography>
                </InputAdornment>
              ),
            }}
          />

          <TextField
            fullWidth
            placeholder="Enter your email*"
            margin="dense"
            value={formData.email}
            onChange={(e) => handleFieldChange('email', e.target.value)}
            error={Boolean(errors.email)}
            helperText={errors.email}
            sx={{
              mb: 0.5,
              '& .MuiOutlinedInput-root': {
                borderRadius: '12px',
              },
              '& .MuiFormHelperText-root': {
                fontSize: '11px',
                marginTop: 0
              }
            }}
            inputProps={{ style: { fontSize: 14 } }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <img src={emailIcon} alt="email" style={{ width: 18, marginRight: 10 }} />
                </InputAdornment>
              ),
            }}
          />

          {errors.submit && (
            <Typography color="error" fontSize={12} mb={1}>
              {errors.submit}
            </Typography>
          )}

          <FormControlLabel
            control={
              <Checkbox
                size="small"
                checked={agreed}
                onChange={(e) => setAgreed(e.target.checked)}
              />
            }
            sx={{ mt: 0.5, mb: 0.5 }}
            label={
              <Typography sx={{ fontSize: 12 }}>
                I agree to the{' '}
                <Typography component="span" sx={{ color: '#0052ff', fontWeight: 500, fontSize: 12 }}>
                  Terms of Service
                </Typography>{' '}
                and{' '}
                <Typography component="span" sx={{ color: '#0052ff', fontWeight: 500, fontSize: 12 }}>
                  Privacy Policy
                </Typography>
              </Typography>
            }
          />

          {errors.agreed && (
            <Typography color="error" fontSize={12} mb={1}>
              {errors.agreed}
            </Typography>
          )}

          <Button
            variant="contained"
            fullWidth
            disabled={loading}
            onClick={handleRegister}
            sx={{
              bgcolor: '#0052ff',
              color: '#fff',
              py: 1.2,
              fontWeight: 500,
              borderRadius: 2,
              mt: 1,
              fontSize: 14,
              textTransform: 'none',
            }}
          >
            Create Account
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default Register;